import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class OrganisationBranchConnectionCatalogRuleApiService extends ApiService {
  readonly resourcePath = 'organisation_branch_connection_catalog_rules';

  create(data: object): Observable<any> {
    return this.restCreate<any>(data);
  }

  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }

  remove(id: string): Observable<null> {
    return this.restDelete(id);
  }

  // The rules of one connection hang off the connection itself, not off this resource. This API
  // answers subresources with a plain array as well as with a Hydra collection, so take either:
  // reading 'hydra:member' off an array yields undefined and throws once we map over it.
  listByConnection(connectionId: string): Observable<any[]> {
    return this.http.get<any>(this.apiUrl + '/organisation_branch_connections/' + connectionId + '/catalog_rules').pipe(
      map(response => Array.isArray(response) ? response : (new HydraCollection<any>(response).members ?? []))
    );
  }
}
